module.exports = __webpack_public_path__ + "img/EE.b2c90555.svg";